import type { FilterValue } from "@repo/design-system/types/filter";
import type {
  LocationOptionTreeNode,
  Option,
  OptionTree,
} from "@repo/design-system/types/filtermenu";
import { leafify, rootify } from "./utils";

export const handleSelect = (
  // biome-ignore lint/suspicious/noExplicitAny: actionMeta will be removed if react-select is patched out
  update: (newFilter: Option[], _actionMeta: any) => void,
  option: Option,
  activeFilters: Option[]
) => {
  update([...activeFilters, option], {
    action: "select-option",
    option,
  });
};

export const handleRemove = (
  // biome-ignore lint/suspicious/noExplicitAny: actionMeta will be removed if react-select is patched out
  update: (newFilter: Option[], _actionMeta: any) => void,
  option: Option,
  activeFilters: Option[]
) => {
  update(
    activeFilters.filter((f) => f.value !== option.value),
    { action: "deselect-option", option }
  );
};

export type OnValueRemove = typeof handleRemove;

/**
 * Returns all selected child values of the location-select
 */
export function checkIsSelected(
  activeFilters: Option[],
  optionsTree: LocationOptionTreeNode[]
) {
  const activeValues = activeFilters?.map((option) => option.value);
  return leafify(activeValues, optionsTree);
}

export function clearFilter(
  // biome-ignore lint/suspicious/noExplicitAny: _actionMeta can be removed if we remove react-select
  onChange: (newFilter: Option[], _actionMeta: any) => void
) {
  onChange([], { action: "clear", removedValues: [] });
}

export function handleToggleLocationSelect({
  isSelected,
  selectedValues,
  leafValues,
  options,
  onChange,
}: {
  isSelected: boolean;
  selectedValues: FilterValue[];
  leafValues: FilterValue[];
  options: OptionTree;
  onChange: (newFilter: FilterValue[]) => Promise<void>;
}) {
  if (isSelected) {
    // Remove all leafs of this node from checked
    const newChecked = rootify(
      selectedValues.filter((value) => !leafValues.includes(value)),
      options.optionsTree || []
    ) as FilterValue[];

    onChange(newChecked);
  } else {
    // Add all leafs of this node to checked
    const newChecked = rootify(
      [...new Set([...selectedValues, ...leafValues])],
      options.optionsTree || []
    ) as FilterValue[];
    onChange(newChecked);
  }
}
